import { saveDocumentAndWait } from "@/taskpane/utility/saveDocumentAndWait";
import { showNotice } from "@/taskpane/utility/notice";

export const NOT_SAVED_MESSAGE = "Your document is still saving. Please wait a moment and try again.";

// Saves the document and waits for Word to finish. Resolves true when it is safe to run a server-side
// action on the SharePoint copy; on a timeout it tells the user and resolves false so the caller aborts.
export async function ensureDocumentSaved(notify = showNotice) {
  const saved = await saveDocumentAndWait();
  if (!saved) notify(NOT_SAVED_MESSAGE);
  return saved;
}
